import { StateCreator } from 'zustand';
import type { OmnichannelSavedFiltersList, SelectList, FilterTypeObject, LocalType } from '../types';

const setFilterData = (data: string[]) => {
  const list = data?.map((item: string) => ({
    label: item,
    value: item,
  }));
  return {
    list: list || [],
    cache: list || [],
    value: data || [],
  };
};

export type FiltersState = {
  omnichannelSavedFiltersList: OmnichannelSavedFiltersList[];
  omnichannelSavedFiltersSelectList: SelectList[];
  nameSavedFilter: string;
  produto: FilterTypeObject;
  rede: FilterTypeObject;
  cidade: FilterTypeObject;
  uf: FilterTypeObject;
  productFilterType: 'TODOS' | 'ESPECIFICOS';
  localFilterType: LocalType;
  selectedSavedFilter: OmnichannelSavedFiltersList | null;
  showModalOmnichannelSaveFilters: boolean;
};

export type FiltersActions = {
  setOmnichannelClearSavedFilters: () => void;
  setOmnichannelSavedFiltersList: (id: number) => void;
};

export const filtersInitialState: FiltersState = {
  produto: {
    list: [],
    cache: [],
    value: [],
  },
  rede: {
    list: [],
    cache: [],
    value: [],
  },
  cidade: {
    list: [],
    cache: [],
    value: [],
  },
  uf: {
    list: [],
    cache: [],
    value: [],
  },
  omnichannelSavedFiltersList: [],
  nameSavedFilter: '',
  omnichannelSavedFiltersSelectList: [],
  productFilterType: 'TODOS',
  localFilterType: 'TODO_TERRITORIO',
  selectedSavedFilter: null,
  showModalOmnichannelSaveFilters: false,
};

type FiltersSlice = FiltersState & FiltersActions;

export const createFiltersSlice: StateCreator<FiltersSlice> = set => ({
  ...filtersInitialState,
  setOmnichannelClearSavedFilters: () => {
    set({ showModalOmnichannelSaveFilters: false, nameSavedFilter: '' });
  },
  setOmnichannelSavedFiltersList: (id: number) => {
    set(state => {
      const data = state.omnichannelSavedFiltersList.find((item: OmnichannelSavedFiltersList) => item.idFiltroSalvo === id);
      if (!data) return state;

      const local = data.ufs?.length && data.ufs.length > 0 ? 'UF' : data.cidades?.length && data.cidades.length > 0 ? 'CIDADE' : 'TODO_TERRITORIO';
      const hasProducts = data.gtins?.length && data.gtins.length > 0 ? 'ESPECIFICOS' : 'TODOS';
      const redes = setFilterData(data.redes ?? []);
      const cidades = setFilterData(data.cidades ?? []);
      const ufs = setFilterData(data.ufs ?? []);

      return {
        omnichannelSavedFiltersList: state.omnichannelSavedFiltersList.map((item: OmnichannelSavedFiltersList) => (item.idFiltroSalvo === id ? data : item)),
        rede: redes,
        cidade: cidades,
        uf: ufs,
        productFilterType: hasProducts,
        localFilterType: local,
      };
    });
  },
});
